package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.exura.ui.ExuraColors
import com.exura.ui.TextStyles
import com.exura.ui.color
import com.exura.ui.modifiers.ShadeBorder
import com.exura.ui.modifiers.insetHoverableItemStyle
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px


@Composable
internal fun EditViewSection(
    enabled: Boolean = true,
    title: String,
    modifier: Modifier = Modifier,
    withTitle: Boolean = true,
    content: @Composable (Boolean) -> Unit,
) {
    if(enabled) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .borderRadius(0.px)
                .padding(8.px)
                .textAlign(TextAlign.Start)
                .insetHoverableItemStyle(
                    isSelected = enabled,
                    shadeSize = 12.px,
                    shadeBorders = listOf(
//                        ShadeBorder.TOP,
//                        ShadeBorder.LEFT,
//                        ShadeBorder.BOTTOM,
//                        ShadeBorder.RIGHT,
                        ),
                    isHoverable = false,
                )
                .then(modifier),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (withTitle) {
                SpanText(
                    text = title,
                    modifier = Modifier
                        .classNames(TextStyles.medium16)
                        .color(if (enabled) ExuraColors.ARSENIC else ExuraColors.GRAY)
                        .weight(2f)
                        .minWidth(200.px)
                )
            }
            Box(
                modifier = Modifier
                    .padding(16.px)
                    .borderRadius(16.px)
                    .weight(5f)
                    .fillMaxSize(),
                contentAlignment = Alignment.TopStart,
            ) {
                content(enabled)
            }
        }
    }
}
